import {Label} from './label';
import {UnitConverter} from '../utils/unit-converter';
import {CommonUtil} from '../../common/utils/common.util';

export class PolygonTitleLabel extends Label {
  private nameStyles: Array<string> = [
    'color: black',
    'display:block',
  ];
  private areaStyles: Array<string> = [
    'color: #C32F00',
    'display:block',
  ];
  private perimeterStyles: Array<string> = [
    'color: #134A79',
    'display:block',
  ];

  constructor(id: string) {
    super(id);
  }

  private priceStyles: Array<string> = [
    'color: #1a7f37',
    'font-weight: 600',
    'display:block',
  ];

  updateLabelText(name: string, area: number, perimeter: number, showName: boolean, showArea: boolean, showPerimeter: boolean, showPriceLabel: boolean, priceText: string = '') {
    let text = '';
    if (name && name.length > 0 && showName) {
      // text = `<div style="${this.nameStyles.join(';')}">${name.replace(/[&\/\\#,+()$~%.'":*?<>{}]/g, '')}</div>`;
      text = `<span style="${this.nameStyles.join(';')}">${CommonUtil.escapeHtml(name)}</span>`;
    } else {
      text = '';
    }
    if (showArea) {
      text += `<span style="${this.areaStyles.join(';')}">${UnitConverter.areaToString(area)}</span>`;
    }
    if (showPerimeter) {
      text += `<span style="${this.perimeterStyles.join(';')}">${UnitConverter.distanceToString(perimeter)}</span>`;
    }
    if (showPriceLabel && priceText) {
      text += `<span style="${this.priceStyles.join(';')}">${CommonUtil.escapeHtml(priceText)}</span>`;
    }

    this.text = text;
  }

}
